import { Routes } from '@angular/router';
import { LayoutComponent } from './components/client/layout/layout.component';
import { HomeComponent } from './components/client/home/home.component';
import { UserDashboardComponent } from './components/user/user-dashboard/user-dashboard.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { AdminLoginComponent } from './components/auth/admin-login/admin-login.component';
import { AuthGuard } from './service/guards/auth.guard';
import { OverviewTabComponent } from './components/user/overview-tab/overview-tab.component';
import { PortfoliosTabComponent } from './components/user/portfolios-tab/portfolios-tab.component';
import { TransactionsTabComponent } from './components/user/transactions-tab/transactions-tab.component';
import { InvestorWalletTabComponent } from './components/user/investor-wallet-tab/investor-wallet-tab.component';
import { AnalyticsTabComponent } from './components/user/analytics-tab/analytics-tab.component';
import { SettingsTabComponent } from './components/user/settings-tab/settings-tab.component';
import { DisclaimerComponent } from './components/pages/disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/pages/terms-and-conditions/terms-and-conditions.component';
import { SuperadminDashboardComponent } from './components/superAdmin/superadmin-dashboard/superadmin-dashboard.component';
import { SuperadminActivityComponent } from './components/superAdmin/superadmin-activity/superadmin-activity.component';

export const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {path: '', redirectTo: '', pathMatch: 'full'},
            {path: '', component: HomeComponent},
           
        ]
    },
    {
        path:'user', component : UserDashboardComponent, canActivate: [AuthGuard], data: { roleType: 'user' },
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'overview' },
            { path: 'overview', component: OverviewTabComponent },
            { path: 'portfolios', component: PortfoliosTabComponent },
            { path: 'transactions', component: TransactionsTabComponent },
            { path: 'wallet', component: InvestorWalletTabComponent },
            { path: 'analytics', component: AnalyticsTabComponent },
            { path: 'profile', component: SettingsTabComponent },
        ]
    },
    {
        path:'admin', component:AdminDashboardComponent, canActivate: [AuthGuard], data: { roleType: 'admin' },
        children: [
            
        ]
    },
    {
        path:'admin/login', component:AdminLoginComponent
    },
    {
        path:'superadmin', 
        component: SuperadminDashboardComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'activity' },
            { path: 'activity', component: SuperadminActivityComponent }
        ]
    },
    {
        path: 'verify-email',
        loadComponent: () =>
          import('../app/components/auth/verify-email/verify-email.component').then(m => m.VerifyEmailComponent)
      },
      {
        path: 'reset-password',

        loadComponent: () =>
          import('../app/components/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: 'verify-email-change',
        loadComponent: () =>
          import('../app/components/auth/verify-email-change/verify-email-change.component').then(m => m.VerifyEmailChangeComponent)
      },
      {
        path: 'verify-email-sent',
        loadComponent: () =>
          import('../app/components/auth/verify-email-sent/verify-email-sent.component').then(m => m.VerifyEmailSentComponent)
      },
     {path:'privacy-policy', component:PrivacyPolicyComponent},
    {path:'terms-and-conditions', component:TermsAndConditionsComponent},
    {path:'disclaimer', component:DisclaimerComponent}

      

];
